import React, { useState } from 'react';
import SegmentSizeRevenueChart from '../segmentSizeRevenueChart';
import SegmentTtdPerformanceChart from '../segmentTtdPerformanceChart';
import Tabs from '../../../components/Tabs/Tabs';
import {
  OTS_SGM_MNG_CHART_TAB_DELIVERY_REVENUE,
  OTS_SGM_MNG_CHART_TAB_TRADE_DESK_PERFORMANCE,
} from '../../../content';
import { RateLevel } from '../../../constants';
import * as Styled from './index.styles';

export type ChartTab = 'delivery-revenue' | 'trade-desk-performance';

interface SegmentDetailChartsProps {
  segmentId: string;
  rateLevel?: RateLevel;
  advertiserId?: string;
  partnerId?: string;
}

export const SegmentDetailCharts: React.FC<SegmentDetailChartsProps> = ({
  segmentId,
  rateLevel = RateLevel.SYSTEM,
  advertiserId,
  partnerId,
}) => {
  const [activeChartTab, setActiveChartTab] = useState<ChartTab>(
    'delivery-revenue'
  );

  return (
    <Styled.Wrapper>
      <Styled.TabsContainer>
        <Tabs
          tabs={[
            {
              title: OTS_SGM_MNG_CHART_TAB_DELIVERY_REVENUE,
              active: activeChartTab === 'delivery-revenue',
              onClick: () => setActiveChartTab('delivery-revenue'),
            },
            {
              title: OTS_SGM_MNG_CHART_TAB_TRADE_DESK_PERFORMANCE,
              active: activeChartTab === 'trade-desk-performance',
              onClick: () => setActiveChartTab('trade-desk-performance'),
            },
          ]}
        />
      </Styled.TabsContainer>
      <Styled.ChartContent>
        <Styled.ChartPanel $visible={activeChartTab === 'delivery-revenue'}>
          <SegmentSizeRevenueChart
            segmentId={segmentId}
            rateLevel={rateLevel}
            advertiserId={advertiserId}
            partnerId={partnerId}
          />
        </Styled.ChartPanel>
        <Styled.ChartPanel $visible={activeChartTab === 'trade-desk-performance'}>
          <SegmentTtdPerformanceChart
            segmentId={segmentId}
            rateLevel={rateLevel}
            advertiserId={advertiserId}
            partnerId={partnerId}
          />
        </Styled.ChartPanel>
      </Styled.ChartContent>
    </Styled.Wrapper>
  );
};

export default SegmentDetailCharts;
